import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-title-bg",
  "use": "icon-title-bg-usage",
  "viewBox": "0 0 68 24",
  "content": "<symbol viewBox=\"0 0 68 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-title-bg\">\n<path d=\"M4 8.54643C11.5 10 26.5 10.4 39.1316 4C35.5789 12.8 26.8947 20 26.8947 20C34.3947 14.4 53.7368 12.8 64 16.3807\" stroke=\"currentColor\" stroke-width=\"8\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol